import React, { useRef, useState } from "react";
import { DataDownloader } from "./components/DataDownloader";
import { formatChemicalFormulas } from "./utilities";
import SideBarRadioButtons from "./components/SideBarRadioButtons";
const TABLE_METADATA = {
    "Źródła emisji": {
        title: "Współczynnik emisji dla sektora gospodarstw domowych",
        description: "Współczynnik emisji sektora gospodarstw domowych w g emisji zanieczyszczenia na GJ energii w paliwie. Iloczyn współczynnika emisji oraz ilości paliwa umożliwia oszacowanie emisji z domu/mieszkania.",
    },
    "Paliwo SJ": {
        title: "Współczynnik emisji dla sektora energii i przemysłu (pyły i SO2, NOx) dla jednostek istniejących (g/GJ)",
        description: "Współczynnik emisji sektora energii i przemysłu (elektrownie, ciepłownie, elektrociepłownie zawodowe i przemysłowe powstałe przed IX 2027) emisji zanieczyszczenia na GJ energii w paliwie. Iloczyn współczynnika emisji oraz ilości paliwa umożliwia oszacowanie emisji z elektrowni, ciepłowni lub elektrociepłowni.",
    },
    "Paliwo NJ": {
        title: "Współczynnik emisji dla sektora energii i przemysłu (pyły i SO2, NOx) dla jednostek nowych (g/GJ)",
        description: "Współczynnik emisji sektora energii i przemysłu (elektrownie, ciepłownie, elektrociepłownie zawodowe i przemysłowe powstałe po VIII 2027) emisji zanieczyszczenia na GJ energii w paliwie. Iloczyn współczynnika emisji oraz ilości paliwa umożliwia oszacowanie emisji z elektrowni, ciepłowni lub elektrociepłowni.",
    },
    "Paliwo inne": {
        title: "Współczynnik emisji dla sektora energii i przemysłu (CO2 i CH4)",
        description: "Współczynnik emisji sektora energii i przemysłu (elektrownie, ciepłownie, elektrociepłownie zawodowe i przemysłowe) emisji zanieczyszczenia na GJ energii w paliwie. Iloczyn współczynnika emisji oraz ilości paliwa umożliwia oszacowanie emisji z elektrowni, ciepłowni lub elektrociepłowni.",
    },
};
export function EnvironmentalTablesApp({ tables, fileDownloadLink, checkboxData }) {
    var _a, _b;
    const printContentRef = useRef(null);
    const chosenCategory = {
        chosenCategoryId: "tables",
        chosenCategory: ((_a = checkboxData.groups[0]) === null || _a === void 0 ? void 0 : _a.name) || "Wskaźniki emisji",
    };
    const [chosenValue, setChosenValue] = useState({
        chosenValueId: tables.length > 0 ? tables[0].sheetName : "",
        chosenValueLabel: tables.length > 0 ? tables[0].sheetName : "",
    });
    const radioButtonClickHandle = (category, categoryId, value, valueId) => {
        setChosenValue({
            chosenValueId: valueId,
            chosenValueLabel: value,
        });
    };
    const multiRadioButtonsConfig = [
        {
            category: ((_b = checkboxData.groups[0]) === null || _b === void 0 ? void 0 : _b.name) || "Wskaźniki emisji",
            categoryId: "tables",
            filters: [],
            values: tables.map((table) => {
                var _a;
                return ({
                    id: table.sheetName,
                    value: ((_a = TABLE_METADATA[table.sheetName]) === null || _a === void 0 ? void 0 : _a.title) || table.sheetName,
                    callback: radioButtonClickHandle,
                });
            }),
        },
    ];
    const selectedTable = tables.find((t) => t.sheetName === chosenValue.chosenValueId);
    const metadata = selectedTable ? TABLE_METADATA[selectedTable.sheetName] : null;
    return (React.createElement("div", { className: "container my-5" },
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-3" },
                React.createElement(SideBarRadioButtons, { multiRadioButtonsConfig: multiRadioButtonsConfig, chosenCategory: chosenCategory, chosenValue: chosenValue, pageType: "environmental_indicators_data" })),
            React.createElement("div", { className: "col-9" },
                React.createElement("div", { className: "print-area", ref: printContentRef }, selectedTable && metadata && (React.createElement("div", { className: "card mb-4" },
                    React.createElement("div", { className: "card-header" },
                        React.createElement("h5", { className: "mb-0" }, formatChemicalFormulas(metadata.title))),
                    React.createElement("div", { className: "card-body" },
                        React.createElement("p", { className: "text-muted mb-3" }, formatChemicalFormulas(metadata.description)),
                        React.createElement("div", { className: "table-responsive" },
                            React.createElement("table", { className: "table table-bordered table-sm" },
                                React.createElement("thead", null,
                                    React.createElement("tr", null, selectedTable.headers.map((header, hIdx) => (React.createElement("th", { key: hIdx, className: "text-center" }, formatChemicalFormulas(header))))),
                                    selectedTable.units && (React.createElement("tr", { className: "table-secondary" }, selectedTable.units.map((unit, uIdx) => (React.createElement("th", { key: uIdx, className: "text-center fw-normal" }, unit)))))),
                                React.createElement("tbody", null, selectedTable.rows.map((row, rIdx) => (React.createElement("tr", { key: rIdx }, row.map((cell, cIdx) => (React.createElement("td", { key: cIdx, className: cIdx === 0 ? "" : "text-end" }, cell !== null && cell !== undefined ? cell : ""))))))))))))),
                React.createElement(DataDownloader, { downloadLink: fileDownloadLink, printContentRef: printContentRef })))));
}
